export const baseMutations = {
    saveExecutives(state, data) {
        state.executives = data.data.reverse()
    },
    saveEstates(state, data) {
        state.estates = state.estates
            .concat(data.data.data.reverse())
            .sort((a, b) => a.ordering - b.ordering)
        state.currentEstatePage = data.currentPage
    },
    noMoreEstates(state) {
        state.getNewEstates = false
    },
    setCurrentExecutive(state, data) {
        state.currentExecutive = state.executives.find(executive => executive.slug == data)
    },
    saveHouses(state, data) {
        state.houses = data.data.reverse()
                .sort((a, b) => a.ordering - b.ordering)
    },
    setCurrentHouse(state, data) {
        state.currentHouse = state.houses.find(house => house.slug == data)
    },
    saveSliders(state, data) {
        state.sliders = data.data
    },
    saveSiteData(state, data) {
        state.mapAPIKey = data.data && data.data[0] ? data.data[0].mapAPIKey : ''
        state.brochure_url = data.data && data.data[0] ? data.data[0].brochure_url : ''
        state.agent_form_url = data.data && data.data[0] ? data.data[0].agent_form_url : ''
    },
    setMapAvailable(state, data) {
        state.mapAvailable = data
    },
    saveContactOffices(state, data) {
        state.contactOffices = data.data && data.data
            .sort((a, b) => a.ordering - b.ordering)
    },
    saveTestimonials(state, data) {
        state.testimonials = data.data && data.data
            .sort((a, b) => a.ordering - b.ordering)
    },
    saveContactData(state, data) {
        state.contactData = data.data && data.data[0]
    },
    subscribe(state, data) {
        state.subscribeResponse = data
        state.subscribeStatus = false
    },
    saveBlogPosts(state, data) {
        state.articles = state.articles.concat(data.data.data)
        state.currentArticlePage = data.currentPage
    },
    noMoreBlogPosts(state) {
        state.getNewPages = false
    },
    resetSubscribe(state) {
        state.subscribeResponse = ''
    },
    savePrivacy(state, data) {
        state.privacyContent = data.data
    },
    setSubscribeStatus(state, data) {
        state.subscribeStatus = data
    },
    setCurrentArticle(state, data) {
        state.currentArticle = state.articles.find(article => article.slug == data)
    },
    setLoadingState(state, data) {
        state.loadingState = data
    },
}